export default {
  modelName: (n = 1) => '',
  processingStatus: '',
  paymentStatus: '',
  registration: '',
};
